import { useMemo, useState, type ReactNode } from 'react';
import type { Clinic } from '@leoclinic/types';
import { USE_MOCK_DATA } from '@/config/app.config';
import { buildMockSession } from '@/config/mock-session';
import { AuthContext } from './auth-context';

interface AuthProviderProps {
  children: ReactNode;
}

/**
 * Provider de autenticação — suporta modo demo sem Supabase
 */
export function AuthProvider({ children }: AuthProviderProps) {
  const [mockClinicOverrides, setMockClinicOverrides] = useState<Partial<Clinic>>({});

  const mockSession = useMemo(
    () => (USE_MOCK_DATA ? buildMockSession(mockClinicOverrides) : null),
    [mockClinicOverrides],
  );

  const updateMockClinic = (data: Partial<Clinic>) => {
    setMockClinicOverrides((prev) => ({ ...prev, ...data }));
  };

  const value = useMemo(
    () => ({
      useMock: USE_MOCK_DATA,
      mockSession,
      updateMockClinic: USE_MOCK_DATA ? updateMockClinic : undefined,
    }),
    [mockSession],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
